import { render, staticRenderFns } from "./writing.vue?vue&type=template&id=b6b227a8&scoped=true"
import script from "./writing.vue?vue&type=script&lang=js"
export * from "./writing.vue?vue&type=script&lang=js"
import style0 from "./writing.vue?vue&type=style&index=0&id=b6b227a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b227a8",
  null
  
)

export default component.exports